<template>
    <div class="consent-edit-group">
        <slot />
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.consent-edit-group {
    & + .card-info,
    .card-info + & {
        margin-top: 17px;
    }
}
</style>
